import { DMEData, generalSettings, registerWidget } from "dmeditor";
import { Youtube } from "./Youtube";

const register = () => {
  registerWidget(
    {
      type: "youtube",
      icon: "",
      name: "Youtube list",
      category: "basic",
      settings: [
        {
          name: "Channel ID",
          property: ".channelID",
          settingComponent: "input",
        },
        {
          name: "apiKey",
          property: ".apiKey",
          settingComponent: "input",
        },
        {
          name: "Height",
          property: ".height",
          settingComponent: "number",
        },
      ],
      events: {
        updateData: () => {},
        createBlock: (): DMEData.CreatedBlock => {
          return {
            type: "youtube",
            data: {
              channelID: "",
              apiKey: "AIzaSyBjpfv4KCOhQwtN5EyEY8k1CEowhzddvF4",
              list: [],
            },
          };
        },
      },
    },
    {
      render: Youtube,
    }
  );
};

export default register;
